import React, { useCallback, useEffect, useState } from "react";
import imageUploadUtilInstance from "../../../../APIs/util";
import { useNavigate, useParams } from "react-router-dom";
import { useNotification } from "../../../Toast/Notification";
import FormFaq from "../formFaq/FormFaq";
import { Category, Faq } from "../../../../@types/faq";
import faqServiceInstance from "../../../../APIs/faq";

const EditFaq: React.FC = () => {

  const [selectedCategoryId, setSelectedCategoryId] = useState<any>();
  const navigate = useNavigate();
  const { notify } = useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setcategories] = useState<Category[]>([]);
  const [question, setQuestion] = useState<string>("");
  const [editorContent, setEditorContent] = useState<string>("");
  const { id } = useParams();


  const resetForm = () => {
    setQuestion("");
;
  };


  const handleEditorChange = (content: string) => {
    setEditorContent(content);
  };

  const handleImageUpload = async (
    blobInfo: any,
    success: (url: string) => void,
    failure: (error: string) => void
  ) => {
    let file = blobInfo.blob ? blobInfo.blob() : null;

    if (!file && blobInfo.url) {
      success(blobInfo.url);
      return;
    }

    if (file) {
      try {
        const { data, } = await imageUploadUtilInstance.uploadImage(file);

        if (typeof data === "string") {
          success(data);
        } else {
          failure("Image upload failed, no URL returned");
        }
      } catch (err) {
        failure("Image upload failed");
      }
    } else {
      failure("No valid image file detected");
    }
  };

  const handleFormSubmit = async () => {
    setIsLoading(true);
    const faqData: Faq = {
      question,
      answer: editorContent,
      categoryId: selectedCategoryId,
      created_at: "",
      updated_at: "",
      id
    };

    try {
      const { data, error } = await faqServiceInstance.editFaq(id, 
        
        faqData);

      if (data) {
        resetForm();
        fetchCategoriesData();
        setTimeout(() => {
          navigate("/dashboard/faqs");
        }, 3000);

        notify("FAQ updated successfully", "success");
      } else {
        console.error("Error updating FAQ:", error);
        notify("Error creating FAQ", "error");
      }
    } catch (error) {
      console.error("Error updating FAQ:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCategoriesData = async () => {
    try {
      const { data, error } = await faqServiceInstance.getAllCategories();

      if (data) {
        setcategories(data);
      } else {
        console.error("Error fetching FAQs:", error);
      }
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  const fetchBlogData = useCallback(async () => {
    if (id) {
      try {
        const { data, error } = await faqServiceInstance.getFaqById(id);
  
        if (data) {
          setQuestion(data.question);
          setSelectedCategoryId(data.id);
          setEditorContent(data.answer);
        } else {
          console.error("Error fetching blog:", error);
        }
      } catch (error) {
        console.error("Error fetching blog:", error);
      }
    }
  }, [id]);

  useEffect(() => {
    fetchCategoriesData();
    if (id) {
      fetchBlogData();
    }
  }, [fetchBlogData, id]);

  return (
    <div className="bg-white p-4 rounded-md w-5/4 mx-auto">
      <h2
        className=" pl-4  box-border text-[rgb(0,34,56)]
             block text-[20px] text-left h-[38px] font-semibold
            leading-[38.4px] mb-1">
        Edit Question
      </h2>

      <FormFaq
        editorContent={editorContent}
        handleEditorChange={handleEditorChange}
        handleFormSubmit={handleFormSubmit}
        isLoading={isLoading}
        handleImageUpload={handleImageUpload}
        question={question}
        setQuestion={setQuestion}
        selectedCategoryId={selectedCategoryId}
        setCategoryId={setSelectedCategoryId}
        categories={categories}
      />
    </div>
  );
};

export default EditFaq;
